<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.documentDetail.document.modalCancel.title')"
    @close="closeDialog"
    max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem' }"
          />
        </div>
        <div>
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            <span>{{ $t('message.documentDetail.document.modalCancel.body') }}</span>
          </p>
          <p class="mb-4 text-zt-dark-500">
            <span>
              {{ $t('message.documentDetail.document.modalCancel.legend') }}
            </span>
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="zt-modal-footer rounded-b flex justify-end items-center p-4">
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
          data-vs-button="closeDialog"
        >
          {{ $t('message.documentDetail.document.modalCancel.buttonCancel') }}
        </zt-button>
        <zt-button
          class="w-25"
          :loader="isLoading"
          @click="confirmChanges"
          data-vs-button="confirmChanges"
        >
         {{ $t('message.documentDetail.document.modalCancel.buttonOk') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>
<script>
export default {
  name: 'ConfirmCancelDialogDialog',
  inject: ['activeCancelDialog', 'cancelDocumentInformation'],
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    active() {
      this.isLoading = false
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    closeDialog() {
      if (this.isLoading) return
      this.activeCancelDialog(false)
    },
    async confirmChanges() {
      try {
        this.isLoading = true
        await this.cancelDocumentInformation()
        this.isLoading = false
        this.closeDialog()
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #eeeeee;
}
.text-custom-legend {
  font-size: 1.125rem;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
      0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: 0.375rem !important;
  }
  button.button-cancel {
    color: #707070 !important;
    background-color: transparent !important;
  }
}
</style>
